module.exports = __webpack_public_path__ + "img/SmartphoneMockUp.7b420e74.png";